<template>
  <div>
    <div style="margin-bottom: 10px; margin-top: 10px; margin-left: 10px; width: 99%;">
      <div style="float: left">
        <el-button @click="search()">查询</el-button>
      </div>
      <div style="float: right; margin-right: 20px">

      </div>
    </div>

    <div>

      <el-descriptions :column="4" border size="mini">
        <el-descriptions-item label="姓名">
          <el-input size="mini" placeholder="请输入姓名" v-model="params.name" clearable></el-input>
        </el-descriptions-item>
      </el-descriptions>

    </div>

    <div style="margin-top: 10px;">
    </div>

    <el-table ref="Table" :data="pageData.list" :cell-style="cellStayle">
      <el-table-column fixed prop="name" label="姓名" align="center" width="" fixed></el-table-column>
      <el-table-column prop="project" label="项目" align="center" width="180" fixed></el-table-column>
      <el-table-column prop="salary_year" label="发薪年份" align="center" width="50"></el-table-column>
      <el-table-column prop="salary_month" label="发薪月份" align="center" width="50"></el-table-column>
      <el-table-column prop="ought_to_attendance" label="应出勤" align="center" width="50"></el-table-column>
      <el-table-column prop="practical_attendance" label="实际出勤" align="center" width="50"></el-table-column>
      <el-table-column prop="salary_count_day" label="工资核算天数" align="center" width="50"></el-table-column>
      <el-table-column prop="normal_salary" label="正常工作时间工资" align="center" width=""></el-table-column>
      <el-table-column prop="fixed_overtime_salary" label="固定加班工资" align="center" width=""></el-table-column>
      <el-table-column prop="perf_salary" label="绩效工资" align="center" width=""></el-table-column>
      <el-table-column prop="actual_attendance_salary" label="实际出勤工资" align="center" width=""></el-table-column>
      <el-table-column prop="overtime_salary" label="加班费" align="center" width=""></el-table-column>
      <el-table-column prop="temperature_money" label="高温费" align="center" width=""></el-table-column>
      <el-table-column prop="festival_money" label="过节费" align="center" width=""></el-table-column>
      <el-table-column prop="internship_money" label="顶岗费" align="center" width=""></el-table-column>
      <el-table-column prop="other_money" label="其他奖励" align="center" width=""></el-table-column>
      <el-table-column prop="ought_to_salary" label="应发工资" align="center" width=""></el-table-column>
      <el-table-column prop="housing_provident_fund" label="住房公积金" align="center" width=""></el-table-column>
      <el-table-column prop="agent_subtract_money_total" label="扣除金额" align="center" width=""></el-table-column>
      <el-table-column prop="social_security_money" label="社保费" align="center" width=""></el-table-column>
      <el-table-column prop="housing_provident_fund" label="公积金" align="center" width=""></el-table-column>
      <el-table-column prop="work_injury_insurance" label="工伤险" align="center" width=""></el-table-column>
      <el-table-column prop="income_tax" label="个人税" align="center" width=""></el-table-column>
      <el-table-column prop="other_subtract_money" label="其他扣款" align="center" width=""></el-table-column>
      <el-table-column prop="absence" label="考勤奖罚" align="center" width=""></el-table-column>
      <el-table-column prop="special_reward" label="特殊奖罚" align="center" width=""></el-table-column>
      <el-table-column prop="actual_salary" label="实发工资" align="center" width=""></el-table-column>
      <el-table-column prop="check_status" label="审批状态" align="center" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.check_status == 0">待审核</span>
          <span v-if="scope.row.check_status == 1">待提交</span>
          <span v-if="scope.row.check_status == 2">审批中</span>
          <span v-if="scope.row.check_status == 100">审核失败</span>
          <span v-if="scope.row.check_status == 101">审批失败</span>
          <span v-if="scope.row.check_status == 1000">完成</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width=""></el-table-column>
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.row.check_status == 2" size="mini" type="primary" style="color: #FFFFFF" @click="showEditBox(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background layout="total, prev, pager, next, jumper, sizes"  class="pagination"
                   :total="pageData.total"
                   :current-page="pageData.page"
                   :page-size="pageData.pageSize"
                   :page-sizes="[15, 30, 50, 100]"
                   @current-change="handleCurrentChange" @size-change="handleSizeChange"/>

    <el-dialog title="编辑" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 700px;overflow-y: auto;">
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <el-descriptions-item label="奖罚金额(奖励填写正数，惩罚填写负数)">
            <el-input size="mini" class="form-input" v-model="formData.special_reward"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input type="textarea" placeholder="请输入内容" v-model="formData.remark" maxlength="100"
                      show-word-limit>
            </el-input>
          </el-descriptions-item>

        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="saveForm()">确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import moment from "moment";
import Http from "../common/Http";

export default {
  name: "EditSalaryOrigin",
  data() {
    return {
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      params: {
        month: '',
        project: '',
        name: '',
        check_status: '',
        batch_number : ''
      },
      formData: {
        special_reward : 0,
        remark: '',
        id: 0
      },
      selectList: [],
      dialogVisible: false
    }
  },
  created() {

  },
  mounted() {
    let batchNumber = this.$route.query.batch_number;
    if (batchNumber == '' || typeof batchNumber == 'undefined') {
      this.$message.error({
        message: '缺失批次号！',
        type: "error",
      })
    } else {
      this.params.batch_number = batchNumber;
      this.getList()
    }
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      let params = this.params;
      params['page'] = this.pageData.page
      params['pageSize'] = this.pageData.pageSize
      Http.get(Http.getPreBaseURL() + '/oa/Salary/salaryOriginList', params, res => {
        if (res.code === 0) {
          this.pageData.list = res.data.data;
          this.pageData.page = res.data.current_page;
          this.pageData.pageSize = res.data.per_page;
          this.pageData.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    handleCurrentChange(val) {
      this.pageData.page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getList()
    },
    submitFlow() {
      let list = this.selectList;
      let ids = []
      if (list.length <= 0) {
        this.$message.error({
          message: "请选择需要审批的薪资！",
          type: "error",
        })
        return false
      }
      // 判断是否已经提交过审批的
      for (let i=0; i < list.length; i++) {
        ids.push(list[i]['id'])
        if (list[i]['check_status'] !== 1) {
          this.$message.error({
            message: list[i]['name'] + "已提交薪资审批！",
            type: "error",
          })
          return false
        }
      }

      let params = { ids : ids}
      let that = this
      Http.get(Http.getPreBaseURL() + "/oa/Salary/submitFlow", params, res => {
        if (res.code == 0) {
          // 跳转到流程审批
          that.$router.push({
            path: '/flow/FlowView',
            query: {
              'sheet_id': 40,
              'master_id': 38,
              'timeValue': Date.now(),
              'batch_number': res.data,
            }
          });
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    showEditBox(row) {
      this.dialogVisible = true
      this.formData.remark = row.remark
      this.formData.id = row.id
    },
    saveForm() {
      let that = this
      let params = this.formData
      Http.get(Http.getPreBaseURL() + "/oa/Salary/editOrigin", params, res => {
        if (res.code == 0) {
          that.getList()
          that.dialogVisible = false
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    cellStayle({row, column, rowIndex, columnIndex}) {
      if (column.label === '实际出勤工资') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '加班费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '其他奖励') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '高温费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '顶岗费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '过节费') {
        return 'background-color : #80F6AF'
      }
      if (column.label === '应发工资') {
        return 'background-color : #FFAAAA'
      }

      if (column.label === '住房公积金') {
        if (row.housing_provident_fund > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '扣除金额') {
        if (row.agent_subtract_money_total > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '社保费') {
        if (row.social_security_money > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '公积金') {
        if (row.housing_provident_fund > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '工伤险') {
        if (row.work_injury_insurance > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '个人税') {
        if (row.personal_income_tax > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '其他扣款') {
        if (row.other_subtract_money > 0) {
          return 'background-color : #6BDDFA; color: #FF0000; font-weight:bold'
        } else {
          return 'background-color : #6BDDFA'
        }
      }
      if (column.label === '实发工资') {
        return 'background-color : #FFAAAA'
      }
      if (column.label === '考勤奖罚' || column.label === '特殊奖罚') {
        return 'background-color : #e7d4c1'
      }
    },
  },
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/PreSalary/EditSalaryOrigin.vue